import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from 'vue-router';
import { useAppStore } from '@/stores/app';
import heroBgImage from '@/assets/images/hero-bg.png';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'main',
    component: () => import('@/views/Main.vue'),
    meta: {
      navColor: 'white',
      backdropColor: 'linear-gradient(45deg, #00d2bf, #15bb02, #fbff00)',
      backdropImage: heroBgImage,
    },
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/About.vue'),
    meta: {
      navPage: 'About',
      navColor: 'white',
      backdropColor: 'linear-gradient(150deg,#53f 15%,#05d5ff 70%,#a6ffcb 94%)',
      backdropImage: heroBgImage,
    },
  },
  {
    path: '/support',
    name: 'support',
    component: () => import('@/views/Support.vue'),
    meta: {
      navPage: 'Support',
      navColor: 'white',
      backdropColor: '#ff6868',
      backdropImage: heroBgImage,
    },
  },
  {
    path: '/cookies',
    name: 'cookies',
    component: () => import('@/views/Cookies.vue'),
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: () => import('@/views/Disclaimer.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Initialize nav pages from route meta (called after pinia is ready)
export function initializeNavPages() {
  const store = useAppStore();
  router.getRoutes().forEach((route) => {
    if (route.meta?.navPage) {
      store.addNavPage({
        label: route.meta.navPage as string,
        route: route.name as string,
      });
    }
  });
}

export default router;
